export default __webpack_public_path__ + "static/media/eye-opened.c756436e.svg";